import { type Ref, onMounted } from 'vue'

export const usePinch = (
  element: Ref<HTMLElement>,
  {
    callback,
    unpinchCallback,
    onPinchStart,
    onPichMove,
    onPinchEnd,
  }: {
    callback: (event: TouchEvent) => void
    unpinchCallback?: (event: TouchEvent) => void
    onPinchStart?: (event: TouchEvent) => void
    onPichMove?: (event: TouchEvent) => void
    onPinchEnd?: (event: TouchEvent) => void
  }
) => {
  onMounted(() => {
    let initialDistance = 0
    let currentDistance = 0
    let scale = 1

    element.value.addEventListener('touchstart', (event: TouchEvent) => {
      const { touches } = event

      if (touches.length === 2) {
        initialDistance = calculatePinchDistance(touches)

        onPinchStart?.(event)
      }
    })

    element.value.addEventListener('touchmove', (event: TouchEvent) => {
      const { touches } = event

      if (touches.length === 2) {
        currentDistance = calculatePinchDistance(touches)

        scale = currentDistance / initialDistance

        onPichMove?.(event)
      }
    })

    element.value.addEventListener('touchend', (event: TouchEvent) => {
      if (scale > 1) {
        callback(event)
      }

      if (scale < 1 && unpinchCallback) {
        unpinchCallback(event)
      }

      if (scale !== 1) {
        onPinchEnd?.(event)
      }

      initialDistance = 0
      currentDistance = 0
      scale = 1
    })
  })

  const calculatePinchDistance = (touches: TouchList) => {
    return touches.length === 2
      ? Math.hypot(
          touches[1].clientX - touches[0].clientX,
          touches[1].clientY - touches[0].clientY
        )
      : 0
  }
}
